"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.animateSingularComponentElement = void 0;

var _smartAnimationFrame = require("./smartAnimationFrame");

var animateSingularComponentElement = function animateSingularComponentElement(animationElement, getTargetSnapshot, startSnapshot, animationHandlers, easingFunction, duration, _ref) {
  var onFinishRead = _ref.onFinishRead,
      onFinishWrite = _ref.onFinishWrite,
      onCancel = _ref.onCancel;
  var animationFrame;
  var startingTimestamp;
  var animationObject = {
    ongoing: true,
    cancel: function cancel() {
      var stayOngoing = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (animationFrame) {
        (0, _smartAnimationFrame.cancelSmartAnimationFrame)(animationFrame);
        animationObject.ongoing = stayOngoing;
        onCancel();
      }
    },
    snapshotTrack: {
      rect: {},
      style: {}
    }
  };

  var stepRead = function stepRead(timestamp) {
    startingTimestamp = startingTimestamp ? startingTimestamp : timestamp;
    var progress = timestamp - startingTimestamp;
    var targetSnapshot;

    if (progress < duration) {
      animationFrame = (0, _smartAnimationFrame.requestSmartAnimationFrame)(stepWrite, stepRead);
      targetSnapshot = getTargetSnapshot();
    } else {
      animationFrame = undefined;
      onFinishRead();
    }

    return {
      progress: progress,
      targetSnapshot: targetSnapshot
    };
  };

  var stepWrite = function stepWrite(timestamp, _ref2) {
    var targetSnapshot = _ref2.targetSnapshot,
        progress = _ref2.progress;

    if (progress < duration) {
      var valueFormula = function valueFormula(startValue, endValue) {
        return startValue + (endValue - startValue) * easingFunction(progress / duration);
      };

      animationHandlers.forEach(function (handler) {
        return handler(animationElement, valueFormula, startSnapshot, targetSnapshot, animationObject.snapshotTrack);
      });
    } else {
      animationObject.ongoing = false;
      onFinishWrite();
    }
  };

  animationFrame = (0, _smartAnimationFrame.requestSmartAnimationFrame)(stepWrite, stepRead);
  return animationObject;
};

exports.animateSingularComponentElement = animateSingularComponentElement;
var _default = animateSingularComponentElement;
exports["default"] = _default;